module.exports = __webpack_public_path__ + "static/media/rocket.76536f70.png";